'use client'

/**
 * "Show some love" - the always-available tip entry point in the navbar, beside Status.
 *
 * Copy is "Show SOME love", not "show US some love" (owner, 2026-08-13): this is a one-man
 * operation and "us" implied a company that is not there. Keep the first person out of it.
 *
 * ⛔ NO DROPDOWN. There was one, and it was wrong in three ways the owner hit immediately
 * (2026-08-13): on touch, the first tap opened the card instead of navigating, so you had to tap
 * again; the 8px gap between pill and card meant moving the mouse toward the card dismissed it; and
 * a hover panel over a link that already navigates is two affordances competing for one click.
 *
 * It is now exactly what it looks like: a link. One click goes to /donate. The explanation the card
 * used to hold lives on the donate page itself, which is where someone acting on it is headed
 * anyway. The only motion is a slow heartbeat that stops on hover and under prefers-reduced-motion.
 */

import Link from 'next/link'
import { Heart } from 'lucide-react'

export default function ShowSomeLoveButton() {
  return (
    <Link prefetch={false}
      href="/donate"
      title="Show some love: tip any amount and leave a note"
      className="group/love relative flex items-center gap-1.5 rounded-full border border-amber-500/40 bg-gradient-to-r from-amber-500/15 to-rose-500/10 px-2.5 py-1.5 text-amber-200 transition-all hover:border-amber-400/80 hover:from-amber-500/25 hover:to-rose-500/20 active:scale-95 lg:px-3"
    >
      <Heart className="dt-love-beat-m h-4 w-4 fill-amber-400/25 text-amber-300 transition-transform group-hover/love:scale-110" />
      <span className="hidden text-xs font-bold lg:inline">Show some love</span>
    </Link>
  )
}
